import {Store,Module,ActionContext} from 'vuex'
import ListModule from '../list-module'
import ListState from '../list-state'
import Ajax from '../../../lib/ajax'
import PageResult from '@/store/entities/page-result';
import ListMutations from '../list-mutations';
import Offer from '../../entities/booking/offer';
import Util from '../../../lib/util';

interface OfferState extends ListState<Offer>{
    editOffer:Offer
}
class OfferMutations extends ListMutations<Offer>{

}
class OfferModule extends ListModule<OfferState,any,Offer>{
    state={
        totalCount:0,
        currentPage:1,
        pageSize:10,
        list: new Array<Offer>(),
        loading:false,
        editOffer:new Offer()
    }
    actions={
        async getAll(context:ActionContext<OfferState,any>,payload:any){
            context.state.loading=true;
            let reponse=await Ajax.get('/api/services/app/Offer/GetMyOffers',{params:payload.data});
            context.state.loading=false;
            let page=reponse.data.result as PageResult<Offer>;
            context.state.totalCount=page.totalCount;
            let curDate = new Date();
            let curYear = curDate.getFullYear();
            let curMonth = curDate.getMonth();
            context.state.list=page.items.map(it=>{
                let mDate = new Date(it.startDate);
                if (it.isCopied || (mDate.getFullYear() == curYear && mDate.getMonth() !=curMonth)) {
                    it._disabled = true;
                } else {
                    it._disabled = false;
                }
                return it
            });
        },
        async getAllList(context:ActionContext<OfferState,any>,payload:any){
            context.state.loading=true;
            let reponse=await Ajax.get('/api/services/app/Offer/GetAll',{params:payload.data});
            context.state.loading=false;
            let page=reponse.data.result as PageResult<Offer>;
            context.state.totalCount=page.totalCount;
            let curDate = new Date();
            let curYear = curDate.getFullYear();
            let curMonth = curDate.getMonth();
            context.state.list=page.items.map(it=>{
                let mDate = new Date(it.startDate);
                if (it.isCopied || (mDate.getFullYear() == curYear && mDate.getMonth() !=curMonth)) {
                    it._disabled = true;
                } else {
                    it._disabled = false;
                }
                return it
            });
        },
        async create(context:ActionContext<OfferState,any>,payload:any){
            await Ajax.post('/api/services/app/Offer/Create',payload.data);
        },
        async createMoreOffer(context:ActionContext<OfferState,any>,payload:any){
            await Ajax.post('/api/services/app/Offer/CreateMoreOffer',payload.data);
        },
        async update(context:ActionContext<OfferState,any>,payload:any){
            await Ajax.put('/api/services/app/Offer/Update',payload.data);
        },
        async delete(context:ActionContext<OfferState,any>,payload:any){
            await Ajax.delete('/api/services/app/Offer/Delete?Id='+payload.data.id);
        },
        async get(context:ActionContext<OfferState,any>,payload:any){
            let reponse=await Ajax.get('/api/services/app/Offer/Get?Id='+payload.id);
            return reponse.data.result as Offer;
        }
    };
    mutations={
        setCurrentPage(state:OfferState,page:number){
            state.currentPage=page;
        },
        setPageSize(state:OfferState,pagesize:number){
            state.pageSize=pagesize;
        },
        edit(state:OfferState,offer:Offer){
            state.editOffer=offer;
        }
    }
}
const offerModule=new OfferModule();
export default offerModule;